import React from 'react'
import { AccountContainer } from '../AccountContainer'
import { MainProfile } from './MainProfile'
import { RecentOrder } from './RecentOrder'
import { Stack } from 'react-bootstrap'
import { PageTitle } from '../../../components/PageTitle'

export const Layout = () => {
  return (
    <AccountContainer>
      <PageTitle title="My Account" description="View and manage your account details, orders, and preferences." />
      <Stack gap={3}>
        <MainProfile />

        <RecentOrder />
      </Stack>
    </AccountContainer>
  )
}
